import { BASE_V_MANAGE_URL } from "../apis/apiConstants";
import { getCookie } from "../serviceWorker";

const getNormalizedMonitorPath = path => {
  if (!path) return "";
  return path.startsWith("/") ? path : `/${path}`;
};

const getTenantIdFromAnalyticsCookie = analyticsCookie => {
  if (!analyticsCookie) return "";

  try {
    const parsedCookie = JSON.parse(analyticsCookie);
    if (parsedCookie?.tenancyMode !== "tenant") return "";

    const tenantId = parsedCookie?.tenantId;
    return tenantId === undefined || tenantId === null ? "" : `${tenantId}`.trim();
  } catch (error) {
    console.warn("Failed to parse cl-analytics cookie, using default vManage URL", error);
    return "";
  }
};

export const getVManageMonitorUrl = (
  path = "",
  analyticsCookie = getCookie("cl-analytics")
) => {
  const normalizedPath = getNormalizedMonitorPath(path);
  const tenantId = getTenantIdFromAnalyticsCookie(analyticsCookie);

  if (tenantId) {
    return `/#/${encodeURIComponent(tenantId)}/app/monitor2${normalizedPath}`;
  }

  return `${BASE_V_MANAGE_URL}${normalizedPath}`;
};
